import { Link } from "react-router-dom";
import ManualEntryFlow from "../components/ManualEntryFlow";

export default function ManualEntryPage() {
  return (
    <main className="min-h-screen bg-washi px-6 py-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/cards" className="text-sm text-navySoft hover:underline">
          ← 一覧に戻る
        </Link>
        <h2 className="serif mt-4 text-2xl font-medium text-navy">
          手動で名刺を追加
        </h2>
        <p className="mt-2 mb-8 text-sm text-navySoft">
          1 件ずつ名刺情報を入力して Google Sheets に追加します。氏名以外は省略可。英語面はオプションです。
        </p>
        <ManualEntryFlow />
      </div>
    </main>
  );
}
